const preferrableWidgetReducer = (widget = 'attendance', action) => {
    switch (action.type) {
        case "ADD_PREFERRABLE_WIDGET":
            return action.payload;
        default:
            return widget;
    }
};

export default preferrableWidgetReducer;